export default __webpack_public_path__ + "static/media/verify-image.18e5fb53.jpg";